import { render, staticRenderFns } from "./adminhome.vue?vue&type=template&id=389d2ce6&scoped=true"
import script from "./adminhome.vue?vue&type=script&lang=js"
export * from "./adminhome.vue?vue&type=script&lang=js"
import style0 from "./adminhome.vue?vue&type=style&index=0&id=389d2ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d2ce6",
  null
  
)

export default component.exports